export async function getSeonSession() {
    try {
        const config = {
            geolocation: {
                canPrompt: false,
            },
            networkTimeoutMs: 2000,
            fieldTimeoutMs: 2000,
            region: 'eu',
            silentMode: true,
        };
        const seonSession = window?.seon?.getSession ? (await window.seon.getSession(config) || undefined ) : undefined;
        return seonSession;
    } catch (err) {
        console.error("getSeonSession error:", err);
        return undefined;
    }
}